import { apiGet } from '@/api/http';

import type { RecruiterWorkspace } from '@/types/recruiterProject';

const apiUrl = import.meta.env.VITE_API_URL;

export const listRecruiterWorkspaces = () =>
  apiGet<RecruiterWorkspace[]>(`${apiUrl}recruiter-workspaces/`);
